<div class="video-container w-100 h-100">
  <div class="player-card w-100 h-100">
    <div *ngIf="!isHideInfo" class="player-header">
      <button *ngIf="obj_Cam?.fullName" type="button" class="player-title" (click)="openLink()"
        [attr.aria-label]="'مشاهده خودرو ' + obj_Cam.fullName" [title]="obj_Cam.fullName">
        <span>{{ obj_Cam.fullName | faNum }}</span>
      </button>
      <span *ngIf="obj_Cam?.channel" class="player-channel">{{ obj_Cam.channel }}</span>
    </div>

    <div class="player-stage" [style.max-height]="maxHeight">
      <div *ngIf="(tripId && tripId > 0) && ScreenShot" class="player-screenshot">
        <button type="button" class="player-action" title="گرفتن عکس" aria-label="گرفتن عکس" (click)="takeScreenshot()">
          <i class="fa fa-camera" aria-hidden="true"></i>
        </button>
      </div>
      <video #video controls playsinline webkit-playsinline muted aria-label="تصویر دوربین"></video>
    </div>

    <div *ngIf="!isHideInfo" class="player-footer">
      <div class="player-actions">
        <button type="button" class="player-action" title="ضبط صدا" aria-label="ضبط صدا" (click)="openVoiceRecordModal()">
          <i class="fa fa-microphone" aria-hidden="true"></i>
        </button>
        <button type="button" class="player-action player-action--share" title="اشتراک فیلم" aria-label="اشتراک فیلم" (click)="liveShare()">
          <i class="fa fa-share-alt" aria-hidden="true"></i>
        </button>
      </div>
      <div *ngIf="obj_Cam?.clients || obj_Cam?.liveTime" class="player-meta">
        <span *ngIf="obj_Cam?.clients" class="player-stat" title="تعداد بینندگان" aria-label="تعداد بینندگان">
          <i class="fa fa-users" aria-hidden="true"></i>
          {{ obj_Cam.clients.toLocaleString() | faNum }}
        </span>
        <span *ngIf="obj_Cam?.liveTime" class="player-stat" title="زمان شروع پخش">
          <i class="fa fa-play-circle-o" aria-hidden="true"></i>
          <span dir="ltr">{{ obj_Cam.liveTime | faNum }}</span>
        </span>
      </div>
    </div>
  </div>

  <share-video-modal #shareVideoModal [modalId]="obj_Cam?.strUnitId + '-modal'"
    [strUnitId]="obj_Cam?.strUnitId || obj_Cam?.strUnitID || ''"></share-video-modal>

  <!-- مدال ضبط صدا -->
  <voice-record-modal #voiceRecordModal [modalId]="obj_Cam?.strUnitId + '-voice-record-modal'" [strUnitId]="obj_Cam?.strUnitId"></voice-record-modal>

</div>
